import Repository from '../Repository';

export default {

	getAllSubjectCodes() {
		var response = Repository.get('Subject/GetAllSubjectCodes', {});
		return response;
	},

	getAllSubjects() {
		var response = Repository.get('Subject/GetAllSubjects', {});
		return response;
	}

}
